import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listAnalyses } from '../api/analysisClient';
import GettingStartedCards from '../components/GettingStartedCards';
import HotDealsCard from '../components/HotDealsCard';

const TOOLS = [
  {
    icon: '\u{1F3E0}',
    title: 'Analyze Properties',
    description:
      'Look up properties, estimate renovation costs, find comparable sales, and run full investment analysis.',
    link: '/analyze',
    color: 'var(--primary)',
  },
  {
    icon: '\u{1F4CB}',
    title: 'Listings',
    description:
      'Browse ingested property listings, view AI quality scores, investment recommendations, and map locations.',
    link: '/listings',
    color: '#16a34a',
  },
  {
    icon: '\u{1F4B0}',
    title: 'Flip Calculator',
    description:
      'Model the full lifecycle of a fix-and-flip deal with financing costs, monthly breakdowns, sensitivity analysis, and profitability projections.',
    link: '/flip-calculator',
    color: '#d97706',
  },
  {
    icon: '\u{1F4CA}',
    title: 'Portfolio Dashboard',
    description:
      'View aggregate metrics across all analyzed properties with verdicts, ROI, and cap rates at a glance.',
    link: '/dashboard',
    color: 'var(--success)',
  },
  {
    icon: '\u{1F4C8}',
    title: 'Projects',
    description:
      'Browse imported project cost data and historical benchmarks from past renovations.',
    link: '/projects',
    color: '#8b5cf6',
  },
  {
    icon: '\u{1F4E5}',
    title: 'Import Data',
    description:
      'Upload CSV or Excel cost breakdowns to build your benchmark database for more accurate estimates.',
    link: '/import',
    color: '#0891b2',
  },
  {
    icon: '\u{1F50D}',
    title: 'Compare Projects',
    description:
      'Side-by-side comparison of multiple project cost breakdowns to identify patterns and outliers.',
    link: '/compare',
    color: 'var(--warning)',
  },
];

export default function LandingPage() {
  const [hasAnalyses, setHasAnalyses] = useState<boolean | null>(null);

  useEffect(() => {
    listAnalyses()
      .then((res) => setHasAnalyses(res.analyses.length > 0))
      .catch(() => setHasAnalyses(true)); // On error, fall back to normal view
  }, []);

  return (
    <div className="landing-page">
      <div className="landing-hero">
        <h1>Bay Area Construction Cost Analyzer</h1>
        <p>
          AI-powered renovation cost estimation, comparable sales analysis, and investment
          underwriting for Bay Area real estate.
        </p>
      </div>

      {hasAnalyses === false && <GettingStartedCards />}

      {hasAnalyses && <HotDealsCard />}

      <div className="landing-grid">
        {TOOLS.map((tool) => (
          <Link
            key={tool.link}
            to={tool.link}
            className="landing-card"
            style={{ '--card-accent': tool.color } as React.CSSProperties}
          >
            <div className="landing-card-icon">{tool.icon}</div>
            <div className="landing-card-body">
              <h3>{tool.title}</h3>
              <p>{tool.description}</p>
            </div>
            <span className="landing-card-arrow">&rarr;</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
